<section class="checkout-shell">
    <main class="checkout-workspace">
        <header class="checkout-header">
            <div class="checkout-title">
                <button class="back-button" type="button">‹</button>
                <h1>Checkout</h1>
            </div>

            <button class="edit-button" type="button">✎ Edit order blocks</button>
        </header>

        <section class="toolbar">
            <div class="toolbar-left">
                <button class="view-button" type="button">
                    View : Group by order block ▾
                </button>
            </div>

            <button class="remove-button" type="button">Remove all</button>
        </section>

        <section class="table-card">
            <div class="table-scroll">
                <table>
                    <thead>
                    <tr>
                        <th class="check-cell">
                            <input type="checkbox" aria-label="Select all" />
                        </th>
                        <th class="expand-cell"></th>
                        <th>Security</th>
                        <th>Type</th>
                        <th>Entities</th>
                        <th>Exchange</th>
                        <th>
                            Volume / Units
                            <span>Sim. amount/exposure</span>
                        </th>
                        <th>
                            Price
                            <span>as of</span>
                        </th>
                        <th>Limit</th>
                        <th>Valid until</th>
                        <th>Investment decider</th>
                        <th>Cash account</th>
                        <th>Actions</th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr
                            *ngFor="let row of rows"
                            [class.group-row]="row.level === 0"
                            [class.child-row]="row.level === 1"
                    >
                        <td class="check-cell">
                            <input type="checkbox" aria-label="Select row" />
                        </td>

                        <td class="expand-cell">
                            <button
                                    *ngIf="row.level === 0"
                                    class="expand-button"
                                    type="button"
                            >
                                {{ row.expanded ? '⌄' : '›' }}
                            </button>
                        </td>

                        <td>
                            <div class="security-cell" [class.indented]="row.level === 1">
                                <strong>{{ row.security }}</strong>
                                <span>{{ row.isin }}</span>
                            </div>
                        </td>

                        <td>
                            <div class="type-cell">
                                <span class="type-dot">B</span>
                                <div>
                                    <strong>{{ row.type }}</strong>
                                    <span>Unit</span>
                                </div>
                            </div>
                        </td>

                        <td>
                            <div class="entity-cell">
                                <a href="#">{{ row.entities }}</a>
                                <span *ngIf="row.broker">{{ row.broker }}</span>
                            </div>
                        </td>

                        <td>
                            <div class="muted-cell">
                                <strong>{{ row.exchange }}</strong>
                                <span>{{ row.execution }}</span>
                            </div>
                        </td>

                        <td>
                            <div class="muted-cell">
                                <strong>{{ row.volume }}</strong>
                                <span>{{ row.estimate }}</span>
                            </div>
                        </td>

                        <td>
                            <strong>{{ row.price }}</strong>
                        </td>

                        <td>{{ row.limit }}</td>

                        <td>
                            <div class="muted-cell">
                                <strong>{{ row.validUntil }}</strong>
                                <span>{{ row.dateHint }}</span>
                            </div>
                        </td>

                        <td>{{ row.investmentDecider || '' }}</td>

                        <td>
                            <button
                                    *ngIf="row.cashAccount"
                                    class="account-select"
                                    type="button"
                            >
                                {{ row.cashAccount }} ▾
                            </button>
                        </td>

                        <td>
                            <button class="action-button" type="button">⋯</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <footer class="checkout-footer">
            <div class="footer-summary">
                <div>
                    <strong>0</strong>
                    <span>Single orders</span>
                </div>
                <div>
                    <strong>28</strong>
                    <span>Block orders</span>
                </div>
                <div>
                    <strong>14</strong>
                    <span>ISINs</span>
                </div>
                <div>
                    <strong>4</strong>
                    <span>portfolios</span>
                </div>
                <div>
                    <strong>2</strong>
                    <span>Broker</span>
                </div>
                <div>
                    <strong>6.349.669,88 CHF</strong>
                    <span>turnover</span>
                </div>
                <div>
                    <strong>6.349.669,88 CHF</strong>
                    <span>in buys</span>
                </div>
                <div>
                    <strong>0,00 CHF</strong>
                    <span>in sells</span>
                </div>
            </div>

            <div class="footer-actions">
                <button class="secondary-button" type="button">reopen</button>
                <button class="primary-button" type="button">Check guidelines</button>
            </div>
        </footer>
    </main>
</section>
